import React, { useState, useRef } from 'react';
import { injectIntl} from 'react-intl';
import { getLayout } from '../../lib/ep.js';

import ActionButton from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import SaveButton from '../builder/SaveButton';

import BracketQuestion from './BracketQuestion';
import DirectParticipation from './DirectParticipation';

const Wrapper = (props) => {
	let classname = [];

	return (
		<div class="main_contents_flex">
			<div class={classname.join(" ")}>
				{props.children}
			</div>
		</div>
	)
};

const Paginator = ({ questions, current, colors, ...props }) => {
	if(questions.length == 1) return null;

	const getBackgroundColor = (status) => {
		if(status == 'selected') return colors.main_color;
		return colors.text_color;
	};

	return (
		<ul class="bracket_answering_pagination">
			{questions.map((question, q) => {
				const status = (current === q) ? 'selected' : ((current > q) ? 'passed' : 'future');

				return (
					<li
						key={`q_${q}`}
						class={`is_${status}`}
						style={{
							background:getBackgroundColor(status),
						}}
					/>
				)
			})}
		</ul>
	)
};

const BracketClient = (props) => {
	const stage = props.stage?.Stage ?? props.stage;
	const is_builder = props?.is_builder ?? false;
	const is_test = (is_builder) ? (props?.is_test ?? false) : false;
	const time_between_questions = 0.5;

	//Only questions with no BLANK USERS
	const candidates = props.brackets.candidates.filter((obj) => (obj.BracketCandidate.status == '1'));

	let candidates_index ={};
	candidates.map((candidate) => {
		candidates_index[candidate.BracketCandidate.id] = candidate.BracketCandidate;
	});

	let layout_props = {};
	if(props?.promotion != undefined) {
		layout_props = getLayout(props.promotion);
	}

	const questions = props.questions.filter((q) => {
		if(candidates_index[q.Answer[0].config.bracket_candidate] == undefined) return false;
		if(candidates_index[q.Answer[1].config.bracket_candidate] == undefined) return false;
		return true;
	});

	const [ current, setCurrent ] = useState(0);
	const [ display_loading, setDisplayLoading ] = useState(false);
	const [ display_fake_success, setDisplayFakeSuccess ] = useState(false);
	const [ initialized, setInitialized ] = useState(true);
	const [ participate_result, setParticipateResult ] = useState({});
	const [ user, setUser ] = useState({});

	const submitting = useRef(false);

	const reset = () => {
		setUser({});
		setCurrent(0);
		setParticipateResult({});
		setDisplayLoading(false);
		setDisplayFakeSuccess(false);
	};

	const nextQuestion = () => {
		setDisplayLoading(true);
		setCurrent(current + 1);

		setTimeout(() => {
			goToEndGame();
		}, (time_between_questions * 1000));
	};

	const goToEndGame = () => {
		setDisplayLoading(false);
	};

	const toAnswer = (answer) => {
		const _user = { ...user };
		_user[questions[current].Question.id] = { [answer.id]:1 };
		setUser(_user);

		const ended_quiz = ((current + 1) >= questions.length) ? true : false;

		if(!ended_quiz) {
			nextQuestion();
			return;
		}

		if(is_builder) {
			setTimeout(() => {
				setParticipateResult({ status:1 });
			}, 200);
			return;
		}

		props.submitQuiz(_user, (res) => {
			if(res.status) {
				if(res.next_participation != undefined) {
					const next_participation = res.next_participation;
					if(next_participation !== false && next_participation !== true) {
						res.next_participation = EPDateHumanize(EPDateDuration(EPDateDiff(next_participation)));
					} else {
						res.next_participation = next_participation;
					}
				}

				setParticipateResult(res);
			}
		});
	};

	const setInit = (e, cb) => {
		if(is_builder && !is_test) {
			if(cb != undefined) cb();
			return;
		}

		setTimeout(() => {
			setInitialized(true);
			if(cb != undefined) cb();
		}, (2 * 1000));
	};

	const continueGame = () => {
		if(is_builder) {
			setDisplayFakeSuccess(true);
			return;
		}

		if(submitting.current) return;
		submitting.current = true;

		if(participate_result != undefined && participate_result.url != undefined) {
			window.location.href = participate_result.url;
			return;
		}
	};

	let answers_in_question = [];
	if(questions.length > 0 && (questions[current]?.Answer ?? false)) answers_in_question = questions[current].Answer;

	const bracket_question = (props.brackets.brackets).find((b) => (b.Bracket.id == stage.bracket_id)).Bracket;

	if(participate_result.status && display_fake_success) {
		return (
			<Wrapper>
				<ButtonCollection
					_class={{ other:'flex_button gui_big_button' }}
				>
					<ActionButton
						_fullclass=""
						onClick={reset}
					>Test again</ActionButton>
				</ButtonCollection>
			</Wrapper>
		)
	}

	if(participate_result.status && !display_fake_success) {
		return (
			<Wrapper>
				<DirectParticipation
					stage={{
						Stage:{
							direct_splash_time:3,
						},
					}}
					participate={continueGame}
				/>
			</Wrapper>
		)
	}

	if(!initialized && !is_builder) {
		return (
			<article class="quiz_instructions gui_main_text_color_on_bg">
				<div>
					<div class="instructions_cta">
						<div class="gui_big_button flex_button">
							<SaveButton
								_fullclass=""
								onClick={setInit}
								autotranslate={false}
							>Start</SaveButton>
						</div>
					</div>
				</div>
			</article>
		)
	}

	const filtered_candidates = props.brackets.candidates.filter((obj) => (obj.BracketCandidate.bracket_id == stage.bracket_id));

	const adaptCandidatesForBracket = () => {
		const cands = [];
		filtered_candidates.map((ca) => {
			cands.push(ca.BracketCandidate);
		});
		return cands;
	};

	return (
		<Wrapper>
			{(initialized || (is_builder && !is_test)) && (
				<BracketQuestion
					stage={stage}
					teams={adaptCandidatesForBracket()}
					question={questions[current]}
					answers={answers_in_question}
					bracket={bracket_question}
					current={current}
					total_questions={questions.length}
					answer_click={toAnswer}
					loading={display_loading}
					layout_props={layout_props}
					is_builder={is_builder}
				/>
			)}

			<Paginator
				questions={questions}
				current={current}
				colors={layout_props.color}
			/>
		</Wrapper>
	)
};

export default injectIntl(BracketClient);